import { forwardRef } from 'react';
import type { Ref } from 'react';
import Icon, { icons } from '../Icon';
import InputBase from './InputBase';
import type { InputBaseProps, InputRenderProps } from './InputBase';

type SearchInputProps = Omit<InputBaseProps, 'children' | 'type'>;

/**
 * A generic, controlled search input component for FOSSA.
 *
 */
const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(({
  label,
  value,
  onChange,
  size = 'medium',
  placeholder = 'Search',
  isRequired,
  isDisabled,
  onKeyDown,
  testId,
  maxLength,
}: SearchInputProps, ref: Ref<HTMLInputElement>) => (
  <InputBase
    type="search"
    label={label}
    placeholder={placeholder}
    size={size}
    value={value}
    onChange={onChange}
    isRequired={isRequired}
    isDisabled={isDisabled}
    onKeyDown={onKeyDown}
    testId={testId}
    maxLength={maxLength}
  >
    {(inputBaseProps: InputRenderProps) => (
      <div className="fossa-form__text-input__wrapper">
        <input
          ref={ref}
          // We want to inject a large number of unknown props here, so spreading is necessary.
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...inputBaseProps}
        />
        {/* Placed after so we can target with the sibling selector: .class1 + .class2 */}
        <span className="fossa-form__input__icon" aria-label="Search Icon">
          <Icon icon={icons.search} />
        </span>
      </div>
    )}
  </InputBase>
));

export default SearchInput;
